import Swal from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss'

// よく使うパターンをあらかじめ決めておく
export default class Message {
  static success() {
    return Swal.mixin({
      toast: true,
      icon: "success",
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  }

  static confirm() {
    return Swal.mixin({
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "はい",
      cancelButtonText: "いいえ",
      reverseButtons: true,
    });
  }

  static error() {
    return Swal.mixin({
      icon: "error",
      showConfirmButton: true,
    });
  }
}
